import { Badge, Box, Container, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { SERIES, type DosGame } from '../data/games';

export function PickerView() {
  const navigate = useNavigate();

  return (
    <Container size="lg" py="md">
      <Stack gap="xl">
        <Stack gap={4}>
          <Title order={2}>Arcade</Title>
          <Text size="sm" c="dimmed">
            Pick a cartridge.
          </Text>
        </Stack>

        {SERIES.map((s) => (
          <Stack key={s.seriesSlug} gap="sm">
            <Title order={4}>{s.series}</Title>
            <SimpleGrid cols={{ base: 1, xs: 2, sm: 3 }} spacing="md">
              {s.episodes.map((g) => (
                <GameTile
                  key={g.slug}
                  game={g}
                  onClick={() => g.available && navigate(`/arcade/${g.slug}`)}
                />
              ))}
            </SimpleGrid>
          </Stack>
        ))}
      </Stack>
    </Container>
  );
}

function GameTile({ game, onClick }: { game: DosGame; onClick: () => void }) {
  const disabled = !game.available;
  return (
    <Box
      onClick={disabled ? undefined : onClick}
      style={{
        position: 'relative',
        aspectRatio: '4 / 3',
        borderRadius: 12,
        overflow: 'hidden',
        background: '#111',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.45 : 1,
        boxShadow: '0 6px 18px rgba(0,0,0,0.35)',
        transition: 'transform 120ms ease, box-shadow 120ms ease',
      }}
      onMouseEnter={(e) => {
        if (disabled) return;
        e.currentTarget.style.transform = 'scale(1.02)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      <img
        src={game.coverUrl}
        alt=""
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).style.display = 'none';
        }}
      />
      <Box
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0) 50%)',
        }}
      />
      <Box style={{ position: 'absolute', top: 8, left: 8 }}>
        <Badge color="dark.6" variant="filled" size="sm">
          Ep {game.episode}
        </Badge>
      </Box>
      {disabled && (
        <Box style={{ position: 'absolute', top: 8, right: 8 }}>
          <Badge color="gray" variant="filled" size="sm">
            Coming soon
          </Badge>
        </Box>
      )}
      <Stack gap={2} style={{ position: 'absolute', left: 12, right: 12, bottom: 10 }}>
        <Text c="white" fw={700} size="md" lh={1.1}>
          {game.title}
        </Text>
        <Text c="gray.3" size="xs" lineClamp={2}>
          {game.blurb}
        </Text>
      </Stack>
    </Box>
  );
}
